import { makeStyles } from '@material-ui/core/styles';

const IMAGE = 100;

const useStyles = makeStyles((theme) => ({
  correction: {
    marginLeft: theme.spacing(8),
  },
}));

export default useStyles;
